import React, { useEffect, useState } from "react";
import { FCard, FItem, FList, FListItem, FTypo } from "ferrum-design-system";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/rootReducer";
import {
  TruncateWithoutRounding,
  getCABNInformation,
  getTokenInformationFromWeb3,
} from "../../../utils/global.utils";
import { Crucible_Balance_Tokens } from "./utils";
import { networksMap } from "../../../utils/const.utils";
import { networkLogoMap } from "../../../utils/constants";
import { ThemeProvider, createGlobalStyle } from "styled-components";
import { useParams } from "react-router";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { crucibleSlice } from "../redux/CrucibleSlice";
import { Web3Helper } from "./../../../container-components/web3Client/web3Helper";
import { useWalletConnector } from "foundry";
import { CrucibleClient } from "../../../container-components/web3Client/crucibleClient";
import * as CrucibleActions from "../../../components/crucible/redux/CrucibleActions";

export const CrucibleMyBalance = () => {
  const { tokenData } = useSelector((state: RootState) => state.crucible);
  const { theme } = useSelector((state: RootState) => state.config);
  const dispatch = useDispatch();
  const { farm } = useParams<{ farm?: string }>();
  const { walletAddress, web3Sdk, currentNetworkChainId } =
    useWalletConnector();

  const { userCrucibleDetails } = useSelector(
    (state: RootState) => state.crucible
  );
  const crucible = useSelector(
    (state: RootState) => state.crucible.selectedCrucible
  );

  const DATA_C_TEST_FRM = {
    name: "cFRM",
    chainNetwork: "ARBITRUM",
    network: "cFRM",
    price_percentage: "4.8",
    logo: "https://ferrum.network/nwp/assets/Ferrum-Network/icon-network-cfrm.svg",
    cNetwork: "testFrm",
  };

  const GlobalStyle = createGlobalStyle`
  .mybalance-card {
    background-image: url(${theme?.cards?.crucibleMyBalanceCard}) !important;
  }
`;

  const loadTokenData = async (networkClient: any, network: string = "BSC") => {
    const currencyByCabn = theme.crucibleConfig?.baseCurrency?.cabn || "";
    let crucibleTokens: { [key: string]: string }[] = [];
    if (currencyByCabn) {
      crucibleTokens = [
        {
          currency: currencyByCabn.tokenContractAddress,
          network: (theme?.crucibleConfig?.crucibleFarms || [])[0]?.network,
          token: currencyByCabn.currency?.symbol,
        },
      ];
    }

    if (theme?.crucibleConfig?.crucibleFarms.length > 0) {
      crucibleTokens.push({
        currency: (theme?.crucibleConfig?.crucibleFarms || [])[0]?.contract,
        network: (theme?.crucibleConfig?.crucibleFarms || [])[0]?.network,
        token: (theme?.crucibleConfig?.crucibleFarms || [])[0]?.internalName,
      });
    }

    const networkTokens = crucibleTokens.filter(
      (e) => e.network === (networksMap as any)[currentNetworkChainId]
    );
    for (let item of networkTokens) {
      const tokenDetails = await getTokenInformationFromWeb3(
        networkClient,
        walletAddress,
        item.currency
      );
      const cabnDetails = await getCABNInformation(item.currency);
      let finalData = { ...tokenDetails, ...cabnDetails };
      if (!!finalData) {
        dispatch(
          CrucibleActions.updateTokenData({
            token: item.token,
            ...finalData,
          })
        );
      }
    }
  };

  const loadCrucibleUserInfo = createAsyncThunk(
    "crucible/loadUserInfo",
    async (payload: { crucibleCurrency: string }, ctx) => {
      const actions = crucibleSlice.actions;
      const web3Helper = new Web3Helper(web3Sdk as any);
      const client = new CrucibleClient(web3Helper);
      const userCrucibleDetails = await client.getUserCrucibleInfo(
        ctx.dispatch,
        payload.crucibleCurrency,
        walletAddress as string
      );

      const stakingType = "LP";
      if (!!userCrucibleDetails) {
        if (stakingType === "LP") {
        }
        dispatch(
          actions.userCrucibleDetailsLoaded({
            data: userCrucibleDetails.data,
            token: farm,
          })
        );
      }
    }
  );

  useEffect(() => {
    if (!crucible[farm as any]) {
      loadTokenData(web3Sdk);
    }

    if (
      crucible[farm as any]?.currency ||
      userCrucibleDetails[farm as any]?.baseCurrency
    ) {
      dispatch(
        loadCrucibleUserInfo({
          crucibleCurrency:
            crucible[farm as any]?.currency ||
            userCrucibleDetails[farm as any]?.baseCurrency,
        })
      );
    }
  }, [farm, crucible[farm as any]?.currency, userCrucibleDetails[farm as any]?.baseCurrency]);
  console.log([farm, crucible[farm as any]?.currency, userCrucibleDetails[farm as any]?.baseCurrency], 'logged')
  //@ts-ignore
  const balanceTokens = Crucible_Balance_Tokens[theme.type || "ferrum"];

  return (
    <ThemeProvider theme={theme}>
      <div className={"mybalance-card"}>
        <FTypo
          className="card-title f-mb-1"
          size={20}
          weight={700}
          color={theme?.colors?.primaryLight}
        >
          My Balance
        </FTypo>
        <FList>
          {balanceTokens &&
            balanceTokens?.length &&
            balanceTokens?.map((item: any) => (
              <FListItem key={item.token} className="f-mb-1">
                <FItem display={"flex"} alignY={"center"} className="w-100">
                  <span className="card-balance-images icon-network f-pr--2">
                    <img
                      src={
                        //@ts-ignore
                        networkLogoMap[networksMap[item.network]]
                      }
                      height="24px"
                      width="24px"
                      style={{ marginRight: "3px" }}
                      alt=""
                    />
                    <img
                      src={tokenData[item.token]?.logo || DATA_C_TEST_FRM.logo}
                      height="22px"
                      width="22px"
                      style={{ marginRight: "3px" }}
                      alt=""
                    />
                  </span>
                  <FTypo color={theme?.colors?.primaryLight}>
                    {item.label ||
                      tokenData[item.token]?.label ||
                      DATA_C_TEST_FRM.name}
                  </FTypo>
                </FItem>
                <FTypo
                  size={30}
                  weight={600}
                  align={"end"}
                  display="flex"
                  alignY={"end"}
                  color={theme?.colors?.primaryLight}
                >
                  {TruncateWithoutRounding(tokenData[item.token]?.balance, 3) ||
                    TruncateWithoutRounding(
                      userCrucibleDetails[item.token]?.balance,
                      3
                    ) ||
                    0}
                </FTypo>
              </FListItem>
            ))}
        </FList>
      </div>
      <GlobalStyle />
    </ThemeProvider>

    // <FCard className="card-my-balance styled-card align-v">
    // <FTypo className="card-title" size={20} color="#DAB46E">
    //   My Balance 11111
    // </FTypo>
    // <FList>
    //   {Crucible_Balance_Tokens && Crucible_Balance_Tokens.length && Crucible_Balance_Tokens.map((item: any) => (
    //     <FListItem key={item}>
    //       <FItem display={"flex"} alignY={"center"} className="w-100">
    //         <span className="icon-network f-pr--5">
    //           <img src={tokenData[item]?.logo} height="22px" width="22px" style={{ marginRight: "3px" }} alt="" />
    //         </span>
    //         <FTypo>{tokenData[item]?.symbol}</FTypo>
    //       </FItem>
    //       <FTypo size={30} weight={600} align={"end"} display="flex" alignY={"end"}>
    //         {TruncateWithoutRounding(tokenData[item]?.balance, 3) || 0}
    //       </FTypo>
    //     </FListItem>
    //   ))}
    // </FList>
    // </FCard>
  );
};
